/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrencyModel } from '../../models/currency-model';

export interface GetApiCurrencyV1$Plain$Params {

/**
 * Optional corporate group ID to filter currencies.
 */
  corporateGroupID?: number;

/**
 * Optional date to filter currencies updated after this value.
 */
  updatedAt?: string;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiCurrencyV1$Plain(http: HttpClient, rootUrl: string, params?: GetApiCurrencyV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
  const rb = new RequestBuilder(rootUrl, getApiCurrencyV1$Plain.PATH, 'get');
  if (params) {
    rb.query('corporateGroupID', params.corporateGroupID, {});
    rb.query('updatedAt', params.updatedAt, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CurrencyModel>>;
    })
  );
}

getApiCurrencyV1$Plain.PATH = '/private/v1/currencies';
